import { formatDate } from "@/lib/datetime";

/**
 * Adds when a temporary placement flag is lifted; `flaggedUntil` comes from the
 * pending rollback the API returns as `flagged_until`.
 */
export function withAutoUnflagTime(text, flaggedUntil) {
	if (!flaggedUntil) {
		return text;
	}
	return `${text} (auto-unflag at ${formatDate(flaggedUntil)})`;
}
